"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceType = exports.PaymentTerms = exports.VendorCategory = exports.VendorStatus = exports.PaymentMethod = exports.ExpensePaymentMethod = exports.ExpenseStatus = void 0;
// Expense status enum
var ExpenseStatus;
(function (ExpenseStatus) {
    ExpenseStatus["PENDING"] = "PENDING";
    ExpenseStatus["APPROVED"] = "APPROVED";
    ExpenseStatus["PAID"] = "PAID";
    ExpenseStatus["REJECTED"] = "REJECTED";
})(ExpenseStatus || (exports.ExpenseStatus = ExpenseStatus = {}));
// Payment method (for expenses)
var ExpensePaymentMethod;
(function (ExpensePaymentMethod) {
    ExpensePaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    ExpensePaymentMethod["BANK_TRANSFER"] = "BANK_TRANSFER";
    ExpensePaymentMethod["CHECK"] = "CHECK";
    ExpensePaymentMethod["CASH"] = "CASH";
    ExpensePaymentMethod["PETTY_CASH"] = "PETTY_CASH";
    ExpensePaymentMethod["OTHER"] = "OTHER";
})(ExpensePaymentMethod || (exports.ExpensePaymentMethod = ExpensePaymentMethod = {}));
// export enum PaymentMethod {
//   BankTransfer = 'BankTransfer',
//   CreditCard = 'CreditCard',
//   Cash = 'Cash',
//   Other = 'Other'
// }
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentMethod["BANK_TRANSFER"] = "BANK_TRANSFER";
    PaymentMethod["CASH"] = "CASH";
    PaymentMethod["CHECK"] = "CHECK";
    PaymentMethod["OTHER"] = "OTHER";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
var VendorStatus;
(function (VendorStatus) {
    VendorStatus["Active"] = "Active";
    VendorStatus["Inactive"] = "Inactive";
    VendorStatus["Suspended"] = "Suspended";
})(VendorStatus || (exports.VendorStatus = VendorStatus = {}));
var VendorCategory;
(function (VendorCategory) {
    VendorCategory["Equipment"] = "Equipment";
    VendorCategory["Services"] = "Services";
    VendorCategory["Maintenance"] = "Maintenance";
    VendorCategory["Other"] = "Other";
})(VendorCategory || (exports.VendorCategory = VendorCategory = {}));
var PaymentTerms;
(function (PaymentTerms) {
    PaymentTerms["NET_15"] = "Net 15";
    PaymentTerms["NET_30"] = "Net 30";
    PaymentTerms["EOM"] = "End of Month";
    PaymentTerms["COD"] = "Cash on Delivery";
})(PaymentTerms || (exports.PaymentTerms = PaymentTerms = {}));
// Enum חדש בלבד
var SourceType;
(function (SourceType) {
    SourceType["VENDOR"] = "VENDOR";
    SourceType["STORE"] = "STORE";
})(SourceType || (exports.SourceType = SourceType = {}));
